"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Redo: function() {
        return Redo;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Redo = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        d: "M11.793 2.29303C11.6055 2.48056 11.5002 2.73487 11.5002 3.00003C11.5002 3.26519 11.6055 3.5195 11.793 3.70703L13.086 5.00003H11.5C6.848 5.00003 3 8.84803 3 13.5C3 18.152 6.848 22 11.5 22C16.152 22 20 18.152 20 13.5C20 13.2348 19.8946 12.9805 19.7071 12.7929C19.5196 12.6054 19.2652 12.5 19 12.5C18.7348 12.5 18.4804 12.6054 18.2929 12.7929C18.1054 12.9805 18 13.2348 18 13.5C18 17.048 15.048 20 11.5 20C7.952 20 5 17.048 5 13.5C5 9.95203 7.952 7.00003 11.5 7.00003H13.086L11.793 8.29303C11.6108 8.48163 11.51 8.73423 11.5123 8.99643C11.5146 9.25863 11.6198 9.50944 11.8052 9.69485C11.9906 9.88026 12.2414 9.98543 12.5036 9.9877C12.7658 9.98998 13.0184 9.88919 13.207 9.70703L16.207 6.70703C16.3945 6.5195 16.4998 6.26519 16.4998 6.00003C16.4998 5.73487 16.3945 5.48056 16.207 5.29303L13.207 2.29303C13.0195 2.10556 12.7652 2.00024 12.5 2.00024C12.2348 2.00024 11.9805 2.10556 11.793 2.29303Z",
        fill: "currentColor"
    })
}), "Redo");
const _default = Redo;
